// extracted by mini-css-extract-plugin
export default {"unorderedList":"styles_unorderedList__D4t6r","summaryList":"styles_summaryList__XWHLI"};